import { render, staticRenderFns } from "./FlowArrows.vue?vue&type=template&id=1c6097c1"
import script from "./FlowArrows.vue?vue&type=script&lang=js"
export * from "./FlowArrows.vue?vue&type=script&lang=js"
import style0 from "./FlowArrows.vue?vue&type=style&index=0&id=1c6097c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports